module.exports = __webpack_public_path__ + "static/media/iPhoneNotch.e276ac8e.svg";